<template>
  <div class="w-100 h-100">
    <a-space style="display: flex; justify-content: space-between; padding: 10px 2%">
      <div></div>
      <div v-show="!isF">
        <a-button type="primary" @click="visible = true" style="margin-right: 10px;">{{ $t('maintain.set') }}</a-button>
        <a-button type="primary" @click="s">{{ $t('buttons.fullscreen') }}</a-button>
        <!-- <a-button style="margin-left: 10px">设置</a-button> -->
      </div>
    </a-space>
    <div class="container" style="position: relative;" ref="f">
      <div class="header">
        <div class="header-inner">
          <template v-if="lang === 'en'">
            <dv-decoration-10 style="width: 26%; height: 5px;" />
            <dv-decoration-8 :color="['#54C0F9', 'transparent']" style="width: 12%;height: .4167rem;" />
            <div class="title" style="width: 24%">
              <h1 style="text-align: center; height: .2083rem; margin: .1042rem 0; font-size: .2917rem; color: #fff; font-weight: 600; line-height: .2083rem;">Deman Maintain Warning List</h1>
              <dv-decoration-6 style="width:100%; height: 7px; margin-top: .2083rem;" />
            </div>
            <dv-decoration-8 :reverse="true" :color="['#54C0F9', 'transparent']" style="width: 12%; height: .4167rem;" />
            <dv-decoration-10 style="width:26%; height:5px; transform: rotate(180deg)" />
          </template>
          <template v-else>
            <dv-decoration-10 style="width: 30%; height: 5px;" />
            <dv-decoration-8 :color="['#54C0F9', 'transparent']" style="width: 12%;height: .4167rem;" />
            <div class="title" style="width: 16%">
              <h1 style="text-align: center; height: .2083rem; margin: .1042rem 0; font-size: .2917rem; color: #fff; font-weight: 600; line-height: .2083rem;">德曼维保预警一览表</h1>
              <dv-decoration-6 style="width:100%; height: 7px; margin-top: .2083rem;" />
            </div>
            <dv-decoration-8 :reverse="true" :color="['#54C0F9', 'transparent']" style="width: 12%; height: .4167rem;" />
            <dv-decoration-10 style="width:30%; height:5px; transform: rotate(180deg)" />
          </template>
        </div>
      </div>
      <!--  @mouseenter="stopScroll" @mouseleave="startScroll" -->
      <div class="content">
        <table ref="container">
          <thead>
            <th :style="{ width: column.width ? column.width + 'px' : 'auto'}" v-for="column in columns" :key="column.key">
              <a-tooltip v-if="column.tooltip && column[lang].length > 9" :getPopupContainer="(triggerNode) => triggerNode.parentNode">
                <template slot="title">
                  {{column[lang]}}
                </template>
                {{column[lang]}}
              </a-tooltip>
              <template v-else>
                {{column[lang]}}
              </template>
            </th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in currentData" :key="item.id" :class="{ deep: index % 2 !== 0, shallow: index % 2 === 0}">
              <template v-for="column in columns">
                <td :class="column.key" :style="{ width: column.width ? column.width + 'px' : 'auto'}" v-if="['percentage', 'powerAB', 'temp', 'pres', 'elec'].includes(column.key)" :key="column.key + data.id">{{(item[column.key] * 100).toFixed(0)}}%</td>
                <td :key="column.key" :style="{ width: column.width ? column.width + 'px' : 'auto'}" v-else-if="column.field" :title="item[column.field[0]] ? item[column.field[0]][column.field[1]] : ''">{{ item[column.field[0]] ? item[column.field[0]][column.field[1]] : '' }}</td>
                <td :class="column.key" :style="{ width: column.width ? column.width + 'px' : 'auto'}" v-else :key="column.key + data.id" :title="item[column.key]">{{item[column.key]}}</td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <a-modal v-model="visible" :width="600" :title="$t('tableS')" @ok="saveSetting">
      <a-form-model :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }">
        <a-form-model-item :label="`${$t('overview.listContent.pageGap')}(s)`">
          <a-input-number v-model="form.speed" style="width: 90%" />
        </a-form-model-item>
        <a-form-model-item :label="`${$t('overview.listContent.rows')}`">
          <a-input-number v-model="form.rows" style="width: 90%" />
        </a-form-model-item>
        <a-form-model-item :label="`${$t('warning.leaveDays')}`">
          <a-input-number v-model="form.leaveDays" style="width: 90%" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import warningType from './data'
import { getWarningList } from '@/api/warning'

export default {
  data() {
    return {
      warningType,
      currentIndex: 0,
      columns: [],
      data: [],
      scroll: {
        x: 2500,
        y: 680
      },
      timer: null,
      table: null,
      dialog: {
        title: '',
        visible: false,
        record: {},
        changeFlg: false
      },
      currentPage: 1,
      total: 0,
      currentType: ['MAINTAIN'],
      flag: true,
      currentData: [],
      isF: false,
      visible: false,
      form: {
        speed: 10,
        rows: 17,
        leaveDays: 30
      }
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    currentType: {
      deep: true,
      async handler(value) {
        this.currentPage = 1
        this.total = 0
        this.type = value[0]
        // clearTimeout(this.break)
        this.stopScroll()
        await this.getWarningList()
        this.currentIndex = this.warningType.findIndex(item => item.type === this.type)
        this.columns = this.warningType[this.currentIndex].columns
        this.startScroll()
      }
    }
  },
  created() {
    this.columns = this.warningType[this.currentIndex].columns
    const form = JSON.parse(localStorage.getItem('maintainSetting'))
    if (form) {
      this.form = form
    }
    this.getWarningList()
  },
  mounted() {
    this.table = document.querySelector('tbody')
    setTimeout(this.startScroll, 1000)
    this.flexible()
    document.addEventListener("fullscreenchange", this.hanldeFullscreenchange)
  },
  beforeDestroy() {
    this.stopScroll()
    console.log(this.timer)
  },
  methods: {
    s () {
      this.$refs.f.requestFullscreen()
    },
     flexible () {
      const docEl = document.documentElement
      const dpr = window.devicePixelRatio || 1
      this.setBodyFontSize(dpr)
      this.setRemUnit(docEl)
    },
    setBodyFontSize (dpr) {
      if (document.body) {
        document.body.style.fontSize = (12 * dpr) + 'px'
      } else {
        document.addEventListener('DOMContentLoaded', () => { this.setBodyFontSize(dpr) })
      }
    },
    setRemUnit (docEl, isFullScreen) {
      let rem
      if (isFullScreen) {
        rem = docEl.clientWidth / 20
      } else {
        rem = (docEl.clientWidth < 1440 ? 1440 : docEl.clientWidth) / 20
      }
      docEl.style.fontSize = rem + 'px'
    },
    hanldeFullscreenchange() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer)
      }
      const el = this.$refs.container
      const isFullScreen = document.fullscreenElement !== null
      if (isFullScreen) {
        if (el.clientWidth < window.innerWidth) {
          el.style.width = '98%'
        }
        console.log(el.clientHeight, window.innerHeight);
        this.isF = true
      } else {
        el.style.width = '1640px'
        this.isF = false
      }
    },
    async getWarningList() {
      try {
        this.table && (this.table.scrollTop = 0)
        // if(this.currentType[0] === 'maintain') {
        //   const { data } = await compressorApi.getMaintainList()
        //   this.data = data
        // } else {
        //   const { data } = await warningApi.listAll(this.currentType[0])
        //   this.data = data
        // }
        let params = {}
        if (this.currentType[0] === 'MAINTAIN') {
          params = {
            query: [],
            filter: [
              {
                field: 'leaveDays',
                value: this.form.leaveDays
              }
            ],
            sort: [
              {
                field: 'leaveDays',
                value: 'ASC'
              }
            ]
          }
        }
        const { data } = await getWarningList({
          current: this.currentPage,
          pageSize: this.form.rows,
          latest: true,
          type: this.currentType[0]
        }, params)
        this.data = data.records
        this.currentData = this.data.slice(0, this.form.rows)
        this.total = Math.ceil(data.total / this.form.rows)
        this.$nextTick(() => {
          const trs = document.querySelectorAll('tr')
          if(trs[trs.length - 1].offsetTop + trs[trs.length - 1].clientHeight < this.table.offsetTop + this.table.scrollHeight - 1) {
            trs[trs.length - 1].style.borderBottom = '1px solid #445161'
          }
        })
      } catch {
      }
    },
    startScroll() {
      this.timer = setInterval(() => {
        console.log(this.currentPage, this.total);
        this.currentPage ++
        if(this.currentPage <= this.total) {
          this.getWarningList()
        } else {
          this.currentIndex = this.currentIndex === this.warningType.length - 1 ? 0 : this.currentIndex + 1
          this.currentType = [this.warningType[this.currentIndex].type]
        }
      }, this.form.speed * 1000)
    },
    stopScroll() {
      clearInterval(this.timer)
      this.timer = null
    },
    async saveSetting() {
      localStorage.setItem('maintainSetting', JSON.stringify(this.form))
      this.visible = false
      this.currentType = [this.currentType[0]]
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  // min-height: 105%;
  // background: url('../../../assets/bg.jpg');
  background-color: #192037;
  // overflow: hidden;
  overflow-x: hidden;
  &::-webkit-scrollbar {  /*滚动条整体样式*/
    width: 4px;           /*高宽分别对应横竖滚动条的尺寸*/
    height: 4px;
  }
  &::-webkit-scrollbar-thumb {  /*滚动条滑块*/
    border-radius: 5px;
    background-color: #4961A3;
  }
  &::-webkit-scrollbar-track {  /*滚动条轨道*/
    border-radius: 0;
    background: rgba(0,0,0,0.1);
  }
  .spin {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .header {
    padding-top: 8px;
    margin-bottom: .2083rem;
    .ant-menu {
      background-color: transparent;
      // color: #ccc;
      border-bottom: none;
      color: rgb(19, 25, 47);
    }
    .title {
      height: 40px;
      // background-color: skyblue;
      text-align: center;
      line-height: 40px;
      font-size: 20px;
      font-weight: 600;
      h1 {
        color: #fff;
      }
    }
    .header-inner {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  }
  .content {
    width: 100%;
    overflow: auto;
    &::-webkit-scrollbar {  /*滚动条整体样式*/
      width: .1042rem;           /*高宽分别对应横竖滚动条的尺寸*/
      height: .1042rem;
    }
    &::-webkit-scrollbar-thumb {  /*滚动条滑块*/
      border-radius: 5px;
      background-color: #4961A3;
    }
    &::-webkit-scrollbar-track {  /*滚动条轨道*/
      border-radius: 0;
      background: rgba(0,0,0,0.1);
    }
    table {
      width: 1640px;
      height: 100%;
      // color: #ccc;
      box-sizing: border-box;
      border: 1px solid #4a5665;
      // border-bottom: none;
      // overflow: hidden;
      margin: 0.8% auto;
      thead {
        // background-color: rgba(19, 25, 47, 0.9);
        background-color: #232c48;
        color: #d7e0fd;
      }
      tbody {
        width: 100%;
        display: block;
        // height: calc(100% - 40px);
        // overflow-y: scroll;
        &::-webkit-scrollbar {
          display: none;
        }
        tr.deep {
          background-color: #232c48;
        }
        tr.shallow {
          background-color: #273051;
        }
      }
      .tbody::-webkit-scrollbar {
        width: 8px;
        // background-color: #ccc;
        border-radius: 4px;
      }
      .tbody::-webkit-scrollbar-track {
        width: 8px;
        // background-color: #ccc;
        border-radius: 4px;
      }
      .tbody::-webkit-scrollbar-thumb {
        width: 8px;
        background-color: #4961A3;
        border-radius: 4px;
      }
      thead,
      tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;
        color: #d0d9f6;
      }
      // tbody tr td.border {
      //   border-bottom: 1px solid #445161;
      // }
      th,
      td {
        height: 53px;
        padding-left: 15px;
        font-size: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      th {
        border-right: 1px solid #5b6574;
        // color: #68d8fe;
        line-height: 40px;
      }
      td {
        border-top: 1px solid #445161;
        border-right: 1px solid #445161;
        word-wrap: break-word;
        // color: #61a8ff;
        font-size: 34px;
      }
      td.companyName,
      td.machineType {
        white-space: nowrap;
        overflow: hidden;//文本超出隐藏
        text-overflow: ellipsis;//文本超出省略号替代
      }
    }
  }
  .ant-menu {
    background-color: transparent;
    border-bottom: none;
    margin-left: 1%;
    color: #ccc;
    font-size: 20px;
  }
}
@media screen and (max-width: 1400px) {
  .dv-decoration-10 {
    width: 28% !important;
  }
  .header .title {
    width: 20% !important;
  }
  :-webkit-full-screen {
    .dv-decoration-10 {
      width: 30% !important;
    }
    .header .title {
      width: 16% !important;
    }
  }
}
@media screen and (max-width: 1200px) {
  .dv-decoration-10 {
    width: 25% !important;
  }
  .header .title {
    width: 26% !important;
  }
  :-webkit-full-screen {
    .dv-decoration-10 {
      width: 28% !important;
    }
    .header .title {
      width: 20% !important;
    }
  }
}
@media screen and (max-width: 900px) {
  .dv-decoration-10 {
    width: 20% !important;
  }
  .dv-decoration-8 {
    width: 8% !important;
  }
  .header .title {
    width: 40% !important;
  }
  :-webkit-full-screen {
    .dv-decoration-10 {
      width: 26% !important;
    }
    .header .title {
      width: 24% !important;
    }
  }
}
</style>
